import { useTranslation } from "react-i18next";
import { SettingsSubHeader } from "../SettingsSubHeader";
import { TopicsInterestsEditor } from "../../../interests/TopicsInterestsEditor";

/**
 * Settings entry for editing topic interests. Same editor as the Discovery
 * sheet (search, specialty sections, batch Save) under the settings sub-header;
 * saving stays on the view — the sub-header's back chevron is the way out.
 */
export function InterestsView(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col">
      <SettingsSubHeader title={t("Pick your interests")} />
      <TopicsInterestsEditor
        surface="sheet"
        onSaved={() => {
          // Stay on the view: the success toast confirms, back is explicit.
        }}
      />
    </div>
  );
}
